/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ duration: NonNullable<unknown> }} Admin_Ai_Chat_Status_DoneInputs */

const en_admin_ai_chat_status_done = /** @type {(inputs: Admin_Ai_Chat_Status_DoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Done in ${i?.duration}`)
};

const de_admin_ai_chat_status_done = /** @type {(inputs: Admin_Ai_Chat_Status_DoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fertig in ${i?.duration}`)
};

const es_admin_ai_chat_status_done = /** @type {(inputs: Admin_Ai_Chat_Status_DoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Listo en ${i?.duration}`)
};

const fr_admin_ai_chat_status_done = /** @type {(inputs: Admin_Ai_Chat_Status_DoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Terminé en ${i?.duration}`)
};

const nl_admin_ai_chat_status_done = /** @type {(inputs: Admin_Ai_Chat_Status_DoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Klaar in ${i?.duration}`)
};

/** @type {(inputs: Admin_Ai_Chat_Status_DoneInputs) => LocalizedString} */
const it_admin_ai_chat_status_done = en_admin_ai_chat_status_done;

/** @type {(inputs: Admin_Ai_Chat_Status_DoneInputs) => LocalizedString} */
const pt_br2_admin_ai_chat_status_done = en_admin_ai_chat_status_done;

/** @type {(inputs: Admin_Ai_Chat_Status_DoneInputs) => LocalizedString} */
const pl_admin_ai_chat_status_done = en_admin_ai_chat_status_done;

/** @type {(inputs: Admin_Ai_Chat_Status_DoneInputs) => LocalizedString} */
const hu_admin_ai_chat_status_done = en_admin_ai_chat_status_done;

/** @type {(inputs: Admin_Ai_Chat_Status_DoneInputs) => LocalizedString} */
const ro_admin_ai_chat_status_done = en_admin_ai_chat_status_done;

/**
* | output |
* | --- |
* | "Done in {duration}" |
*
* @param {Admin_Ai_Chat_Status_DoneInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_ai_chat_status_done = /** @type {((inputs: Admin_Ai_Chat_Status_DoneInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Ai_Chat_Status_DoneInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_ai_chat_status_done(inputs)
	if (locale === "de") return de_admin_ai_chat_status_done(inputs)
	if (locale === "es") return es_admin_ai_chat_status_done(inputs)
	if (locale === "fr") return fr_admin_ai_chat_status_done(inputs)
	if (locale === "nl") return nl_admin_ai_chat_status_done(inputs)
	if (locale === "it") return it_admin_ai_chat_status_done(inputs)
	if (locale === "pt-BR") return pt_br2_admin_ai_chat_status_done(inputs)
	if (locale === "pl") return pl_admin_ai_chat_status_done(inputs)
	if (locale === "hu") return hu_admin_ai_chat_status_done(inputs)
	return ro_admin_ai_chat_status_done(inputs)
});
export { admin_ai_chat_status_done as "admin.ai_chat.status_done" }